<div class="user_filter">
    <!-- Contextual Controls -->
    <div class="contextual-controls">
        <!-- Day-wise: Single Date Picker -->
        <div class="date-stepper" *ngIf="timesheetMode === 'day'" role="group" aria-label="Report date">
            <button type="button" mat-icon-button class="timesheet-date-nav-btn"
                [disabled]="isPreviousDateDisabled()"
                (click)="changeDate(true)"
                matTooltip="Previous day">
                <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
            <mat-form-field class="timeline-datepicker">
                <input matInput [matDatepicker]="pickerdate" [value]="selectDate" [min]="minDate" [max]="maxDate"
                    (dateChange)="onSelectDateChange($event)" />
                <mat-datepicker-toggle matIconSuffix [for]="pickerdate"></mat-datepicker-toggle>
                <mat-datepicker #pickerdate></mat-datepicker>
            </mat-form-field>
            <button type="button" mat-icon-button class="timesheet-date-nav-btn"
                [disabled]="isNextDateDisabled()"
                (click)="changeDate(false)"
                matTooltip="Next day">
                <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
        </div>

        <!-- User-wise: Employee Selector + presets + Date Range -->
        <ng-container *ngIf="timesheetMode === 'user' || timesheetMode === 'period'">
            <div class="dateTimeSection user-selection-control" *ngIf="timesheetMode === 'user'">
                <app-employee-search [userList]="employeeList" [placeholder]="'Select Employee'" class="h-full"
                    [selectedEmployeeId]="selectedUser" (employeeSelected)="onEmployeeSelected($event)" [isShowAllEmp]="false">
                </app-employee-search>
            </div>
            <mat-form-field appearance="outline" floatLabel="never" subscriptSizing="dynamic" class="period-shift-filter" *ngIf="timesheetMode === 'period'">
                <mat-select placeholder="Team" [value]="selectedTeamId" (selectionChange)="onTeamSelected($event.value)">
                    <mat-option [value]="null">All teams</mat-option>
                    <mat-option *ngFor="let team of teamList" [value]="team?.id">
                        {{ team?.title?.rendered || team?.name || ('Team #' + team?.id) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" floatLabel="never" subscriptSizing="dynamic" class="period-shift-filter" *ngIf="timesheetMode === 'period'">
                <mat-select placeholder="Shift" [value]="selectedShiftId" (selectionChange)="onShiftSelected($event.value)">
                    <mat-option [value]="null">All shifts</mat-option>
                    <mat-option *ngFor="let shift of shiftList" [value]="shift.id">
                        {{ shift.shift_name || ('Shift #' + shift.id) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div class="user-wise-date-range-block">
                <div class="date-range-trigger-wrap">
                    <button #dateRangeButton type="button" class="date-range-trigger" (click)="openDateDropdown()">
                        <span class="material-symbols-outlined date-range-trigger-icon" aria-hidden="true">calendar_month</span>
                        <span class="date-range-trigger-text">{{ selectedFilterLabel }}</span>
                        <span class="material-symbols-outlined date-range-trigger-caret" aria-hidden="true">expand_more</span>
                    </button>

                    <div
                        *ngIf="isOpenDateDropdown"
                        #dateRangeDropdown
                        class="date-range-dropdown">
                        <mat-form-field class="date-range-picker-form-field" appearance="outline">
                            <mat-date-range-input [rangePicker]="picker" [formGroup]="selectedDateRange" [min]="minDate" [max]="maxDate">
                                <input matStartDate placeholder="Start date" readonly formControlName="start" (dateChange)="onDropdownStartChanged($event)">
                                <input matEndDate placeholder="End date" readonly class="date-range-end-input" formControlName="end" (dateChange)="onDropdownEndChanged($event)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker [startAt]="rangePickerStartAt" panelClass="timesheet-daterange-panel"></mat-date-range-picker>
                        </mat-form-field>
                        <div class="date-range-error" *ngIf="dateRangeError">{{ dateRangeError }}</div>

                        <div class="preset-filters-block">
                            <div class="preset-filters-title">Preset Filters</div>
                            <div class="preset-filters-list">
                                <button
                                    type="button"
                                    class="preset-filter-item"
                                    *ngFor="let f of visiblePresetFilters"
                                    (click)="setDateRangePreset(f)">
                                    {{ f.label }}
                                </button>
                                <button type="button" class="preset-filter-item preset-filter-custom" (click)="setCustomDateRange()">
                                    Custom range…
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>